import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { rejoinCardImages as t } from "./rejoinCardImages.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useNearbyListingsQuery.ts
var i = (i, a) => n({
	queryKey: e.nearby(i, a),
	queryFn: async () => {
		let e = await r.getNearbyListings(i, a);
		return {
			...e,
			items: e.items.map((n) => t(n, e.imageBase))
		};
	},
	enabled: !!i,
	placeholderData: (e) => e
});
//#endregion
export { i as useNearbyListingsQuery };
